import React, { useContext, useEffect, useState } from "react";
import "./Menu_Offcanvas.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Accordion, Nav, Offcanvas } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { luxuryCategory } from "../../../utils/luxuryapis/Home/Homeapi";
import { Context } from "../../../utils/context";

const Menu_Offcanvas = ({ show, onHide }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const handleNavigate = (path) => {
    onHide();
    navigate(path);
  };

  const [categories, setCategories] = useState();

  const getAllLuxuryCategory = async () => {
    const res = await luxuryCategory();
    if (res?.success) {
      setCategories(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllLuxuryCategory();
  }, []);

  const { cartCount, setAddCartModal, signin } = useContext(Context);
  const navigation = [
    {
      name: "New",
      to: "/luxury/all-products",
    },
    {
      name: "Gifts",
      to: `/luxury/products?category_id=${categories?.[0]?.id}&name=${categories?.[0]?.name}`,
    },
    {
      name: "The Selection",
      items: (categories || []).slice(1).map((val) => ({
        name: val?.name,
        to: `/luxury/products?category_id=${val?.id}&name=${val?.name}`,
      })),
    },
    {
      name: "The Collabs ",
      // items: (categories || []).slice(1).map((val) => ({
      //   name: val?.name,
      //   to: `/luxury/products?category_id=${val?.id}&name=${val?.name}`,
      // })),
      to: "/luxury/dgp-autograph-collection",
    },
    {
      name: "Our Services",
      items: [
        { name: "Gift Customisation", to: "/luxury/gift-customisation" },
        { name: "Bespoke Gifting", to: "/luxury/bespock-gift" },
      ],
      // to: "/luxury/help",
    },
    {
      name: "Suggestions",
      to: "/luxury/suggestions",
    },
    {
      name: "Insights",
      to: "/luxury/articles",
    },

    {
      name: "Can We Help You?",
      to: "/luxury/help",
    },

    // {
    //   name: "Article",
    //   to: "/luxury/articles",
    // },
  ];

  const [activeKey, setActiveKey] = useState(null);

  // ✅ Close Offcanvas automatically whenever route changes
  useEffect(() => {
    if (show) {
      onHide();
    }
  }, [location.pathname]);

  return (
    <Offcanvas
      className="Menu_Offcanvas"
      show={show}
      onHide={onHide}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <p className="menu_title">MENU</p>
        </Offcanvas.Title>
        <div className="close_icon_div" onClick={onHide}>
          <FontAwesomeIcon icon={faXmark} className="close_icon" />
        </div>
      </Offcanvas.Header>

      <Offcanvas.Body className="sidebar_main">
        <div className="sidebar_list">
          <Accordion
            flush
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}
            className="orange_accordion"
          >
            {navigation.map((item, index) => {
              const isParent =
                Array.isArray(item.items) && item.items.length > 0;

              if (isParent) {
                const eventKey = `parent-${index}`;
                const isOpen = activeKey === eventKey;

                return (
                  <Accordion.Item eventKey={`parent-${index}`} key={index}>
                    <Accordion.Header>
                      <div
                        className={`menu_item ${
                          isActive(item.to) ? "active" : ""
                        }`}
                      >
                        {item.name}
                      </div>

                      <div className="icon_holder">
                        <FontAwesomeIcon
                          icon={isOpen ? faAngleUp : faAngleDown}
                          className="inner_icon"
                        />
                      </div>
                    </Accordion.Header>

                    <Accordion.Body>
                      <div className="acc_inner_menu">
                        {item.items.map((subItem, subIndex) => (
                          <div
                            key={subIndex}
                            className={`submenu_item ${
                              isActive(subItem.to) ? "active" : ""
                            }`}
                            onClick={() => handleNavigate(subItem.to)}
                          >
                            {subItem.name}
                          </div>
                        ))}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              }

              return (
                <Accordion.Item eventKey={`single-${index}`} key={index}>
                  <Accordion.Header onClick={() => handleNavigate(item.to)}>
                    <div
                      className={`menu_item ${
                        isActive(item.to) ? "active" : ""
                      }`}
                    >
                      {item.name}
                    </div>
                  </Accordion.Header>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>

        <div className="footer_section">
          <div className="inner_div">
            {!signin && (
              <>
                {" "}
                <Nav.Link
                  as={Link}
                  to="/login"
                  onClick={() => handleNavigate("/login")}
                >
                  <p className="inner_text">LOG IN</p>
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/register"
                  onClick={() => handleNavigate("/register")}
                >
                  <p className="inner_text">SIGN UP</p>
                </Nav.Link>
              </>
            )}

            {signin && (
              <Nav.Link
                as={Link}
                to="/luxury/all-orders"
                onClick={() => handleNavigate("/luxury/all-orders")}
              >
                <p className="inner_text">MY ORDERS</p>
              </Nav.Link>
            )}

            <Nav.Link
              as={Link}
              to="/luxury/contact-us"
              onClick={() => handleNavigate("/luxury/contact-us")}
            >
              <p className="inner_text">CONTACT US</p>
            </Nav.Link>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Menu_Offcanvas;
